import axios from 'axios';
import {API_ROOT} from '../../api-config';

export function getTimeOff(response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/timeoff`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined") {
                response(error.response.data);
            } else {
                response({});
            }
        });
}

export function postTimeOff(data, response) {
    axios.defaults.withCredentials = true;
    axios.post(`${API_ROOT}/timeoff`, data, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined" && typeof error.response.data != "undefined") {
                response(error.response.data);
            } else {
                response({Message: "Unknown error"});
            }
        });
}

export function putTimeOffStatus(time_off_id, status, response) {
    axios.defaults.withCredentials = true;
    axios.put(`${API_ROOT}/timeoff/${time_off_id}/status`, {status: status}, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined" && typeof error.response.data != "undefined") {
                response(error.response.data);
            } else {
                response({Message: "Unknown error"});
            }
        });
}
